import { watch } from "vue";
import useProp from "@/composables/useProp";
import type { Ref } from "vue";

//TODO FIGURE OUT HOW TO TYPE THOSE FUCKING EMITS
//BECAUSE THAT ANY AND THE LACK OF TYPECHECKING WILL HAUNT ME FOREVER

/**
 * @function useProp - composable function that gives you a value from a prop that can be changed through emits and can be modifiable without triggering vue
 * @param {Prop extends object} props - reactive object that contains the props, returned from defineProps function
 * @param {PropName extends keyof Props} prop - the name of the prop
 * @param {PropType} defaultValue - the value in case the prop has no default and is needed to not be undefined
 * @param {any} emits - the emits function returned by define emits
 * @param {string} emitName -  the call signature of the emit
 * @returns {Ref<PropType>} the modifiable ref value
 */
export default function useMProp<
  PropType,
  Props extends object,
  PropName extends keyof Props
>(
  props: Props,
  prop: PropName,
  defaultValue: PropType,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  emits: any,
  emitName: string
): Ref<PropType> {
  const value = useProp(props, prop, defaultValue);
  //if the value changes emit the event to change it outside
  watch(value, (newValue) => emits(emitName, newValue));

  return value;
}
